import { Fragment, useState } from "react";
import { champPath, profiles } from "../misc/Static";
import Champ from "../images/Champ";
import Item from "../images/Item";
import Spell from "../images/Spell";
import MatchDetails from "./MatchDetails";
import calcData from "../memos/calcData";
import calcLanes from "../memos/calcLanes";
import MatchExtraDetails from "./MatchExtraDetails";
import Tip from "../misc/Tip";
import styles from "./MatchTinyStandard.module.css";

export const MatchTinyStandard = ({ region, puuid, data, width }) => {
  const [active, setActive] = useState(false);
  const [activeSet, setActiveSet] = useState(false);
  const pid = data ? data.puuid.indexOf(puuid) : false;
  const pOrder = calcLanes(data.lane, data.queue);
  const calc = calcData(data, pOrder, pid, profiles.queues);

  const expandMatch = () => {
    setActive(!active);
    setActiveSet(false);
  };
  const expandSet = () => {
    setActiveSet(!activeSet);
    setActive(false);
  };

  const notTutorial =
    typeof data.perk0 !== "undefined" && data.perk0[pid] > 0 ? true : false;

  return (
    <>
      <div className={styles[calc.result]}>
        <div className={styles.meta}>
          <div>{Math.round(data.duration / 60)} min</div>
          <div>{calc.queue}</div>
          <div>{calc.result.toUpperCase()}</div>
          <div>{calc.time}</div>
        </div>
        <div className={styles[width]}>
          <div className={styles.champcol}>
            <a
              href={
                "https://lolalytics.com/lol/" +
                champPath(data.champion[pid]) +
                "/build/"
              }
            >
              <Champ type="champ50b" id={data.champion[pid]} />
            </a>
            <div className={styles.level}>{data.champLevel[pid]}</div>
            <div className={styles.spells}>
              <Spell type="spell24" id={data.spell[pid][0]} />
              <Spell type="spell24" id={data.spell[pid][1]} />
            </div>
          </div>
          <div className={styles.killstats}>
            <div>
              <Tip name="kills">
                <span className={styles.kills}>{data.kills[pid]}</span>
              </Tip>{" "}
              /{" "}
              <Tip name="deaths">
                <span className={styles.deaths}>{data.deaths[pid]}</span>
              </Tip>{" "}
              /{" "}
              <Tip name="assists">
                <span className={styles.assists}>{data.assists[pid]}</span>
              </Tip>
            </div>
            <div className={styles.kda}>
              <Tip name="kda">
                {calc.kda[pid]}
                {calc.kda[pid] !== "PERFECT" && <> KDA</>}
              </Tip>
            </div>
            <div className={styles.kp}>
              <Tip name="kp">{calc.kp[pid]}% KP</Tip>
            </div>
            <div className={styles.multikill}>
              <Tip name="multikill">{calc.multi[pid]} </Tip>
            </div>
          </div>

          <div className={styles.itemsplus}>
            <div>
              {[0, 1, 2, 6, 3, 4, 5].map((item, i) => (
                <Fragment key={item}>
                  {data.items[pid][item] === 0 && (
                    <div className={styles.placeholder24}></div>
                  )}
                  {data.items[pid][item] > 0 && (
                    <Item key={i} type="item24r" id={data.items[pid][item]} />
                  )}
                </Fragment>
              ))}
              {notTutorial && (
                <div onClick={expandSet}>
                  <div>{activeSet ? "-" : "+"}</div>
                </div>
              )}
            </div>
            {calc.mmmrTier && (
              <div>
                <Tip name="elo">
                  <img
                    src={`https://cdn5.xdx.gg/emblem32/${calc.mmmrTier.toLowerCase()}.webp`}
                    srcSet={`https://cdn5.xdx.gg/emblem32/${calc.mmmrTier.toLowerCase()}.webp 32w,
                             https://cdn5.xdx.gg/emblem64/${calc.mmmrTier.toLowerCase()}.webp 64w,
                             https://cdn5.xdx.gg/emblem96/${calc.mmmrTier.toLowerCase()}.webp 96w`}
                    width="32"
                    height="32"
                    alt={calc.mmmrTier.toLowerCase()}
                  />
                </Tip>
                <div>
                  <Tip name="elo">
                    {calc.mmmrTier} {calc.mmmrDivision}
                    <br />
                    {calc.mmmrLP} LP
                  </Tip>
                </div>
              </div>
            )}
          </div>
          {notTutorial && (
            <div className={styles.expand} onClick={expandMatch}>
              <div>{active ? "-" : "+"}</div>
            </div>
          )}
          {!notTutorial && <div></div>}
        </div>
      </div>
      {active && (
        <MatchDetails
          region={region}
          pid={pid}
          match={data}
          order={pOrder}
          calc={calc}
          width={width}
        />
      )}
      {activeSet && (
        <div className={styles["active" + calc.result]}>
          <MatchExtraDetails match={data} pid={pid} width={width} />
        </div>
      )}
    </>
  );
};

export default MatchTinyStandard;
